import { EditorType } from '../../constants';
import { getLinkDataFromAction as getLinkDataFromAction, shouldCorrectLink, hasLockedParent, LinkData, getLinkUrlData } from '../helpers';
import { EditableItem, editableId } from '../htmlEditor/constants';
import constants from '../indesignEditor/constants';

export interface LinkConfig {
	id: string;
	page: number;
	linkData: LinkData;
	shouldCorrect: boolean;
	isEditedFromBackoffice?: boolean;
	isThemedItem?: boolean;
}

interface LinksData {
	items: LinkConfig[];
	isError: boolean;
}

const getLinkDataFromElement = (element: HTMLElement, spreads: number[][]): LinkData => {
	const linkElement = element.closest('a') as HTMLAnchorElement;
	const linkAction = linkElement.getAttribute('onclick') || '';
	if (linkAction) {
		const pluginLinkData = getLinkDataFromAction(linkAction, spreads);
		if (pluginLinkData) {
			return pluginLinkData;
		}
	}

	return getLinkUrlData(linkElement.href);
};

const getConfig = (
	element: HTMLElement,
	page: number,
	editorType: EditorType,
	spreads: number[][],
	isAccountManagerOrAdmin: boolean,
): LinkConfig => {
	const linkData = getLinkDataFromElement(element, spreads);
	const shouldCorrect = shouldCorrectLink(linkData);

	return {
		id: editorType === EditorType.INDESIGN
			? element.id
			: element.getAttribute(editableId) as string,
		page,
		linkData,
		shouldCorrect,
		isEditedFromBackoffice: shouldCorrect,
		isThemedItem: isAccountManagerOrAdmin && !!element.className.includes(constants.themedItemClassName),
	};
};

const getLinkSelector = (editorType: EditorType): string => {
	if (editorType === EditorType.INDESIGN) {
		return `a > [id*=${constants.parentContainerId}]:not([class*=${constants.lockedClassName}])`;
	}

	return `a [${EditableItem.Image}]`;
};

const isLockedEditableButton = (element: HTMLElement): boolean => {
	const isLinkOnImage = element.className.includes(constants.imageClassName) ||
		element.getAttribute(EditableItem.Image) !== null;

	if (isLinkOnImage) {
		return false;
	}

	const linkElement = element.closest('a');
	const lockedText = linkElement &&
		linkElement.parentElement &&
		linkElement.parentElement.querySelector(`[class*=${constants.textFieldClassName}][class*=${constants.lockedClassName}]`);

	return !!lockedText;
};

// ignore links with empty 'href' or 'target' attributes
const isEditableLink = (element: HTMLElement): boolean => {
	const linkElement = element.closest('a');

	if (!linkElement) {
		return false;
	}

	const href = linkElement.getAttribute('href');
	const target = linkElement.getAttribute('target');

	return !!(href || target);
};

export default (
	page: number,
	htmlDocument: Document,
	editorType: EditorType,
	spreads: number[][],
	isAccountManagerOrAdmin: boolean,
): LinksData => {
	const items: LinkConfig[] = [];
	let isError: boolean = false;

	const editableLinkElements = [
		...htmlDocument.querySelectorAll(getLinkSelector(editorType)),
	].filter((element: HTMLElement) => (
		isEditableLink(element) && !isLockedEditableButton(element) && !hasLockedParent(element)
	)) as HTMLElement[];

	try {
		editableLinkElements.forEach(element => (
			items.push(getConfig(element, page, editorType, spreads, isAccountManagerOrAdmin))
		));
	} catch (err) {
		isError = true;
	}

	return {
		items,
		isError,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableLinks/getData.ts